import React from 'react';
import clsx from 'clsx';

const variants = {
  primary: 'landing-btn--primary',
  secondary: 'landing-btn--secondary',
  ghost: 'landing-btn--ghost',
};

const sizes = {
  sm: 'landing-btn--sm',
  md: 'landing-btn--md',
  lg: 'landing-btn--lg',
};

const LandingButton = ({
  children,
  variant = 'primary',
  size = 'md',
  className,
  href,
  onClick,
  fullWidth = false,
  type = 'button',
  ...props
}) => {
  const classes = clsx(
    'landing-btn',
    variants[variant],
    sizes[size],
    fullWidth && 'landing-btn--full',
    className
  );

  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button type={type} onClick={onClick} className={classes} {...props}>
      {children}
    </button>
  );
};

export default LandingButton;
